import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { mapGetters } from "vuex";
export default {
  name: "PzTitle",
  computed: _objectSpread({}, mapGetters(['header']))
};